export var Language;
(function (Language) {
    Language["FR"] = "fr";
    Language["EN"] = "en";
})(Language || (Language = {}));
